<a [routerLink]="['/']">
    <img
        alt="{{ brand }}"
        src="../../../assets/main-logo.svg"
        onerror="this.src = '../../../assets/main-logo.png'"
    />
    <h2>{{ titleService.getToolbar2() }}</h2>
</a>
